export default function formatMfaChannel(mfaChannelValue: string) {
    if (/^\d{10}$/.test(mfaChannelValue)) {
        return `${mfaChannelValue.substring(0,3)}-${mfaChannelValue.substring(3,6)}-${mfaChannelValue.substring(6)}`;
    }
    return mfaChannelValue;
}